<h1 mat-dialog-title>{{ isEditMode ? ('Edit Team' | translate) : ('Create Team' | translate) }}</h1>

<div mat-dialog-content>
  <form [formGroup]="teamForm" style="margin-top: 1rem">

    <mat-form-field [style.width.px]="350" appearance="outline">
      <mat-label>{{ 'Team Name' | translate }}</mat-label>
      <input formControlName="name" matInput placeholder="{{ 'Enter team name' | translate }}"/>
      <mat-error *ngIf="teamForm.get('name')?.invalid && teamForm.get('name')?.touched">
        {{ 'Name is required' | translate }}
      </mat-error>
    </mat-form-field>

<!--    <mat-form-field [style.width.px]="350" appearance="outline">-->
<!--      <mat-label>{{ 'League' | translate }}</mat-label>-->
<!--      <mat-select formControlName="leagueId">-->
<!--        <mat-option disabled="true" *ngFor="let league of leagues" [value]="league.id">{{ league.name }}</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <div style="margin-top: 1rem;">
      <label>{{ 'Team Icon' | translate }}</label>
      <input (change)="onFileSelected($event)" accept="image/*" type="file"/>
    </div>

    <div *ngIf="previewUrl" style="margin-top: 1rem;">
      <img [src]="previewUrl" alt="Image Preview" style="max-width: 100%; max-height: 150px;">
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button (click)="onCancel()" mat-button>{{ 'Cancel' | translate }}</button>
  <button (click)="onSave()" color="primary" mat-button [disabled]="!teamForm.valid || (!selectedFile && !isEditMode)">
    {{'Update Team' | translate}}
  </button>
</div>
